export enum AnalyticsEvents {
  NETWORK_CALL_EVENT = 'NETWORK_CALL_EVENT',
  CRASH_EVENT = 'CRASH_EVENT',
  TIMER_EVENT = 'TIMER_EVENT',
  MESSAGE_EVENT = 'MESSAGE_EVENT',
  SCRIPT_UNAUTHORIZED_EVENT = 'SCRIPT_UNAUTHORIZED_EVENT',
  V1_EVENT = 'V1_EVENT',
  SDK_FUNCTION_EVENT = 'SDK_FUNCTION_EVENT',
}
